module.exports = __webpack_public_path__ + "static/media/Locations R12.53c09855.csv";